module.exports = __webpack_public_path__ + "static/media/SWSCRC1-18.023075d4.mp3";